import { Button } from "@/components/ui/button";
import { ReportTab } from "@/lib/constant";
import { cn } from "@/lib/utils";

type ReportViewTabProps = {
  tab: ReportTab;
  onTabChange: (t: ReportTab) => void;
};

function ReportViewTab({ tab, onTabChange }: ReportViewTabProps) {
  return (
    <div className="flex gap-3">
      {Object.values(ReportTab).map(t => (
        <Button
          type="button"
          variant="ghost"
          size="lg"
          key={t}
          onClick={() => onTabChange(t)}
          className={cn(
            "flex-1 rounded-lg py-7 text-base font-bold transition-colors",
            tab === t
              ? "bg-white text-primary hover:text-primary/80 hover:bg-primary/10"
              : "text-muted-foreground bg-muted hover:text-muted-foreground hover:bg-primary/10",
          )}
        >
          {t === ReportTab.CARD ? "Report Card" : "Review Note"}
        </Button>
      ))}
    </div>
  );
}

export default ReportViewTab;
